import {createContext} from 'react';

export enum FeaturesLockType {
    NONE = 0,
    VERIFICATION_REQUIRED = 1,
    PAYMENT_REQUIRED = 2
}

export const FeaturesLockedContext = createContext(FeaturesLockType.NONE);
